__turbopack_context__.v({
  "calendarIcon": "EventDetails-module-scss-module__lsusvq__calendarIcon",
  "followVenueButtonWrapper": "EventDetails-module-scss-module__lsusvq__followVenueButtonWrapper",
  "locationIcon": "EventDetails-module-scss-module__lsusvq__locationIcon",
  "organizerInfoWrapper": "EventDetails-module-scss-module__lsusvq__organizerInfoWrapper",
  "presenterInfoWrapper": "EventDetails-module-scss-module__lsusvq__presenterInfoWrapper",
  "secondaryText": "EventDetails-module-scss-module__lsusvq__secondaryText",
  "venueAndDateTimeWrapper": "EventDetails-module-scss-module__lsusvq__venueAndDateTimeWrapper",
  "venueRow": "EventDetails-module-scss-module__lsusvq__venueRow",
  "wrapper": "EventDetails-module-scss-module__lsusvq__wrapper",
});
